var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10L21 22H7L14 10ZM18.2476 21L16.4748 18H10.5252L8.75245 21H18.2476ZM13.5 12.9657L15.8839 17H11.1161L13.5 12.9657Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22H22.4375L21.8466 21H24.1683L20.6563 15.5368L19.5944 17.1886L19.025 16.225L20.6563 13.6875L26 22Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.4179078ec7843b25c4f99bc3353d6e0c.svg";
export { ForwardRef as ReactComponent };